import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const CaseHubPage = lazy(() =>
  import('../pages/case-mgmt/HubPage').then((m) => ({ default: m.CaseHubPage }))
)
const CasesPage = lazy(() =>
  import('../pages/case-mgmt/CasesPage').then((m) => ({ default: m.CasesPage }))
)
const CaseDetailPage = lazy(() =>
  import('../pages/case-mgmt/CaseDetailPage').then((m) => ({ default: m.CaseDetailPage }))
)
const CaseAnalyticsPage = lazy(() =>
  import('../pages/case-mgmt/AnalyticsPage').then((m) => ({ default: m.CaseAnalyticsPage }))
)
const CaseMgmtSettingsPage = lazy(() =>
  import('../pages/case-mgmt/SettingsPage').then((m) => ({ default: m.CaseMgmtSettingsPage }))
)
const CaseMgmtAuditTrailPage = lazy(() =>
  import('../pages/case-mgmt/AuditTrailPage').then((m) => ({ default: m.CaseMgmtAuditTrailPage }))
)

export const caseMgmtRoutes: RouteObject[] = [
  {
    path: 'case-mgmt',
    children: [
      { index: true, element: <CaseHubPage /> },
      { path: 'hub', element: <CaseHubPage /> },
      { path: 'cases', element: <CasesPage /> },
      { path: 'cases/:id', element: <CaseDetailPage /> },
      { path: 'analytics', element: <CaseAnalyticsPage /> },
      { path: 'settings', element: <CaseMgmtSettingsPage /> },
      { path: 'audit-trail', element: <CaseMgmtAuditTrailPage /> },
    ],
  },
]
